<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { auth, db, user, functions, hashtag } from './stores.js';
    import SignIn from './components/SignIn.svelte';
    export let mode;
    let title;
    let status= "";
    let isCreatingHACO = false;
    let hacoId;
    const dispatch = createEventDispatcher();
    let keyword1, keyword2, keyword3;

    let filterBy = "all";
    let userSocial;
    let hacos=[];
    let keywordsSet;
    let keywordFilters;

    let copy = "copy";


    $: keywords = [keyword1, keyword2, keyword3].filter(keyword => keyword).map(keyword => keyword.toLowerCase());

    $: hacosFiltered = filterBy === "all" ? hacos : hacos.filter(haco => haco.keywords.includes(filterBy));
    $: filters = keywordsSet ? Array.from(keywordsSet).sort() : [];

    console.log("user: ", $user);


    onMount(async () => {
        $db.collection("hacos")
            .onSnapshot((querySnapshot) => {
                hacos = [];
                let filterArray = [];
                querySnapshot.forEach((doc) => {
                    hacos = [...hacos, {...doc.data(), id: doc.id}];
                    filterArray = [...filterArray, ...doc.data().keywords]
                });
                console.log("hacos: ", hacos);
                console.log("filterArray: ", filterArray);
                keywordsSet = new Set(filterArray);
            });

        if ($user){
            loadInfo($user.uid);
        }
    });

	$auth.onAuthStateChanged(function(userAuthState) {
		if(userAuthState){
            loadInfo(userAuthState.uid);
		} else {
			// console.log('onAuthStateChanged no user');
			// $user = null;
		};
	});

    function loadInfo(uid) {
        // get logged in social account
        $db.collection("users").doc(uid).get().then((doc) => {
            if (doc.exists) {
                console.log("User data: ", doc.data());
                userSocial = {...doc.data()}
                console.log("userSocial: ", userSocial);

            } else {
                console.error("No such document");
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
    };


    function launchHACOCloseModal(){
        console.log('launchHACOCloseModal: ', hacoId);
        dispatch('launchHACOCloseModal', {
            id: hacoId
        });
    }

    async function createHACO(){
        if (title){
            status = "Creating your HACO..."
            isCreatingHACO = true;
            console.log("createHACO");

            const createHACO = $functions.httpsCallable('createHACO');
            createHACO({ title, keywords, userSocial })
                .then((result) => {
                    console.log("createHACO result: ",result);
                    if (result.data.hacoId){
                        hacoId = result.data.hacoId;
                        status = "HACO Created!";
                    } else {
                        status = "Looks like there was an error. Please try again.";
                        isCreatingHACO = false;
                    }
                }).catch((error)=>{
                    console.log("createHACO error: ", error);
                });
        };
    };

    function copyURL(){
        navigator.clipboard.writeText(`https://cypher.untilit.works/haco/${hacoId}`).then(function() {
        /* clipboard successfully set */
        copy = "copied";
        setTimeout( () => {copy = "copy"}, 1000);
        }, function() {
        /* clipboard write failed */
        });

    }

</script>

<section>
    {#if mode==="create"}
        {#if $user}
            <div>
                <h1>
                    Help A Creator / Coder Out!
                    <br/>Create your HACO
                </h1>
                title: <input bind:value={title} placeholder="Please enter a title." />
                <br/>keywords:
                <br/><input bind:value={keyword1} placeholder="keyword">
                <br/><input bind:value={keyword2} placeholder="keyword">
                <br/><input bind:value={keyword3} placeholder="keyword">
                <br/><button on:click={createHACO} disabled={!title || isCreatingHACO}>create</button>
                <br/>{status}
                {#if hacoId}
                    <br/>Here is your link to share:
                    <br/><a href="https://cypher.untilit.works/haco/{hacoId}" target="_blank">https://cypher.untilit.works/haco/{hacoId}</a><button on:click={copyURL}>{copy} URL</button>
                    <br/><br/><a href="https://twitter.com/intent/tweet?text=%23HACO (Help A Coder/Creator Out!) %0D%0A{title} %0D%0AJoin me at https://cypher.untilit.works/haco/{hacoId} (a @lifelongdev site) %23UntilItWorks %23{$hashtag}" target="_blank">click to share on Twitter</a>
                    <br/><br/><button on:click={launchHACOCloseModal}>Join your HACO</button>
                {/if}
            </div>
        {:else}
            <div>
                Please sign in to create a HACO.
                <SignIn/>    
            </div>
        {/if}
    {:else}
        <div id="hacos-container">
            <div id="controls">
                <fieldset>
                    <legend>filter</legend>
                
                    <label for="all">
                        <input type="radio" bind:group={filterBy} value={"all"} id="all" name="filterBy">
                        all
                    </label><br/>
                    {#each filters as filter}
                        <label for={filter}>
                            <input type="radio" bind:group={filterBy} value={filter} id={filter} name="filterBy">
                            {filter}
                        </label><br/>
                    {/each}
                  </fieldset>
            </div>
            <div id="content">
                <h1>Please make sure to check out the HACO creator's profile if you don't know them.</h1>
                <div id="container">
                    {#if hacosFiltered.length === 0 }
                        <div>no HACOs</div>
                    {:else}
                        {#each hacosFiltered as haco}
                            <div class="card">
                                {haco.title}
                                <hr>
                                <br/>created by:
                                <br/><a href="https://{haco.provider}/{haco.username}" target="_blank">{haco.username}</a>
                                <br/><button on:click={() => {hacoId = haco.id; launchHACOCloseModal();} }>join</button>
                            </div>
                        {/each}
                    {/if}
                </div>
            </div>
        
        </div>
    {/if}
</section>

<style>
    section {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }

    button {
        cursor: pointer;
    }

    #hacos-container {
        height: 100%;
        width: 100%;
        max-width: 1500px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: auto;

    }

    fieldset {
        text-align: left;
    }

    legend {
        background-color: #000;
        color: #fff;
        padding: 3px 6px;
    }

    label {
        display: inline-block;
    }

    #controls {
        width: 300px;
        margin: 10px;
    }
    #content {
        width: 100%;
        overflow-y: auto;
    }

    #container {
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }

    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1rem;
        border: 1px solid black;
    }

    a {
        text-decoration: underline;
    }



</style>